/** Detect script/language from user text for reply matching */
export const detectUserLanguage = (text = '') => {
  const t = String(text);
  if (/[\u0C80-\u0CFF]/.test(t)) return 'kn';
  if (/[\u0900-\u097F]/.test(t)) return 'hi';
  if (/[\u0B80-\u0BFF]/.test(t)) return 'ta';
  if (/[\u0C00-\u0C7F]/.test(t)) return 'te';
  if (/[\u0D00-\u0D7F]/.test(t)) return 'ml';
  return 'en';
};

const RE = {
  greeting: /^(hi|hello|hey|hy|namaste|ನಮಸ್ಕಾರ|ನಮಸ್ತೆ|ಹಲೋ|ನಮಸ್ಕಾರಾ|नमस्ते|हैलो|हाय)\b/i,
  ubsa: /what is ubsa|ubsaapp|universal book|ಯುಬಿಸಾಯಾಪ್|युबीएसए/i,
  cancel: /cancel|refund|ರದ್ದು|ಮರುಪಾವತಿ|रद्द|रिफंड|रिफ़ंड/i,
  price: /price|cost|how much|availability|available|ಬೆಲೆ|ದರ|उपलब्ध|कीमत|दाम/i,
  hotel: /hotel|stay|villa|homestay|resort|room|book|search|ಹೋಟಲ|ಉಳಿದ|ಬುಕ್|ರಿಸಾರ್ಟ|होटल|बुकिंग|कमरा/i,
  meeting: /meeting|conference|ಮೀಟಿಂಗ|ಸಭಾಂಗಣ|मीटिंग|कॉन्फ़रेंस/i,
  trip: /trip|booking|invoice|reservation|ಪ್ರವಾಸ|ಬುಕಿಂಗ|यात्रा|बुकिंग/i,
  recommend: /recommend|suggest|best|budget|ಸಲಹೆ|शिफारिस|सुझाव/i,
};

const MSG = {
  en: {
    greeting: 'Hello! I am the UBSAAPP AI Assistant. I can help with hotels, meeting rooms, bookings, and your trips.',
    ubsa: '**UBSAAPP** stands for **Universal Book & Stay Advisory App** — discover stays, book meeting rooms, and manage reservations.',
    cancel:
      'For cancellations and refunds:\n• Open **My Trips** (/trips) and select your booking\n• Check status and host policy\n• Refund amounts depend on the property and payment method',
    price:
      'Live prices and availability change often. Use **Search** (/search) with your city and dates, or share your budget and location.',
    hotel:
      'Find hotels, homestays, and resorts on **Search** (/search). Filter by city, dates, and guests.',
    meeting: 'Book meeting rooms on **Meeting Home** (/meeting-home) — search by city, capacity, and amenities.',
    trip: 'Manage bookings in **My Trips** (/trips): status, invoices, and messages to hosts.',
    recommend:
      'Share your **city**, **dates**, and **budget** for tailored search tips, or use **Search** (/search).',
    default:
      'I am the **UBSAAPP AI Assistant**. I can help with hotels, meeting rooms, bookings, and travel. What would you like to do?',
  },
  kn: {
    greeting:
      'ನಮಸ್ಕಾರ! ನಾನು UBSAAPP AI ಸಹಾಯಕ. ಹೋಟಲ್, ಮೀಟಿಂಗ್ ರೂಮ್, ಬುಕಿಂಗ್ ಮತ್ತು ಪ್ರವಾಸಗಳ ಬಗ್ಗೆ ಸಹಾಯ ಮಾಡಬಲ್ಲೆ.',
    ubsa:
      '**UBSAAPP** ಅಂದರೆ **Universal Book & Stay Advisory App** — ವಾಸಸ್ಥಳಗಳು, ಮೀಟಿಂಗ್ ರೂಮ್ ಬುಕಿಂಗ್ ಮತ್ತು ಪ್ರವಾಸ ನಿರ್ವಹಣೆ.',
    cancel:
      'ರದ್ದು ಮತ್ತು ಮರುಪಾವತಿಗೆ:\n• **My Trips** (/trips) ತೆರೆಯಿರಿ ಮತ್ತು ಬುಕಿಂಗ್ ಆಯ್ಕೆಮಾಡಿ\n• ಸ್ಥಿತಿ ಮತ್ತು ಹೋಸ್ಟ್ ನೀತಿ ಪರಿಶೀಲಿಸಿ\n• ಮರುಪಾವತಿ ಮೊತ್ತ ಆಸ್ತಿ ಮತ್ತು ಪಾವತಿ ವಿಧಾನದ ಮೇಲೆ ಅವಲಂಬಿತವಾಗಿರುತ್ತದೆ',
    price:
      'ಬೆಲೆ ಮತ್ತು ಲಭ್ಯತೆ ಬದಲಾಗುತ್ತದೆ. ನಿಮ್ಮ ನಗರ ಮತ್ತು ದಿನಾಂಕಗಳೊಂದಿಗೆ **Search** (/search) ಬಳಸಿ, ಅಥವಾ ಬಜೆಟ್ ಹಂಚಿಕೊಳ್ಳಿ.',
    hotel:
      'ಹೋಟಲ್, ಹೋಮ್‌ಸ್ಟೇ ಮತ್ತು ರಿಸಾರ್ಟ್‌ಗಳಿಗೆ **Search** (/search) ಬಳಸಿ. ನಗರ, ದಿನಾಂಕ ಮತ್ತು ಅತಿಥಿಗಳನ್ನು ಫಿಲ್ಟರ್ ಮಾಡಿ.',
    meeting:
      'ಮೀಟಿಂಗ್ ರೂಮ್ ಬುಕ್ ಮಾಡಲು **Meeting Home** (/meeting-home) — ನಗರ, ಸಾಮರ್ಥ್ಯ ಮತ್ತು ಸೌಲಭ್ಯಗಳಿಂದ ಹುಡುಕಿ.',
    trip:
      '**My Trips** (/trips) ನಲ್ಲಿ ಬುಕಿಂಗ್ ನಿರ್ವಹಿಸಿ: ಸ್ಥಿತಿ, ಇನ್‌ವಾಯ್ಸ್ ಮತ್ತು ಹೋಸ್ಟ್ ಸಂದೇಶ.',
    recommend:
      'ನಿಮ್ಮ **ನಗರ**, **ದಿನಾಂಕ** ಮತ್ತು **ಬಜೆಟ್** ಹಂಚಿಕೊಳ್ಳಿ — ಅಥವಾ **Search** (/search) ಬಳಸಿ.',
    default:
      'ನಾನು **UBSAAPP AI ಸಹಾಯಕ**. ಹೋಟಲ್, ಮೀಟಿಂಗ್ ರೂಮ್, ಬುಕಿಂಗ್ ಮತ್ತು ಪ್ರವಾಸದಲ್ಲಿ ಸಹಾಯ ಮಾಡುತ್ತೇನೆ. ಏನು ಬೇಕು?',
  },
  hi: {
    greeting:
      'नमस्ते! मैं UBSAAPP AI सहायक हूँ। होटल, मीटिंग रूम, बुकिंग और यात्रा में मदद कर सकता/सकती हूँ।',
    ubsa:
      '**UBSAAPP** का अर्थ **Universal Book & Stay Advisory App** है — स्टे, मीटिंग रूम बुकिंग और आरक्षण प्रबंधन।',
    cancel:
      'रद्दीकरण और रिफंड के लिए:\n• **My Trips** (/trips) खोलें और बुकिंग चुनें\n• स्थिति और होस्ट नीति देखें\n• रिफंड राशि संपत्ति और भुगतान पर निर्भर करती है',
    price:
      'कीमत और उपलब्धता बदलती रहती है। शहर और तारीखों के साथ **Search** (/search) उपयोग करें, या बजट बताएं।',
    hotel:
      'होटल, होमस्टे और रिसॉर्ट के लिए **Search** (/search) — शहर, तारीख और मेहमान फ़िल्टर करें।',
    meeting:
      'मीटिंग रूम के लिए **Meeting Home** (/meeting-home) — शहर, क्षमता और सुविधाएँ।',
    trip:
      '**My Trips** (/trips) में बुकिंग प्रबंधित करें: स्थिति, इनवॉइस और होस्ट संदेश।',
    recommend:
      'अपना **शहर**, **तारीख** और **बजट** बताएं — या **Search** (/search) उपयोग करें।',
    default:
      'मैं **UBSAAPP AI सहायक** हूँ। होटल, मीटिंग रूम, बुकिंग और यात्रा में मदद करूँगा/करूँगी। क्या चाहिए?',
  },
};

const pick = (lang) => MSG[lang] || MSG.en;

export const buildLocalizedFallback = (text = '') => {
  const q = String(text);
  const lang = detectUserLanguage(q);
  const m = pick(lang);

  if (RE.greeting.test(q.trim())) return m.greeting;
  if (RE.ubsa.test(q)) return m.ubsa;
  if (RE.cancel.test(q)) return m.cancel;
  if (RE.price.test(q)) return m.price;
  if (RE.hotel.test(q)) return m.hotel;
  if (RE.meeting.test(q)) return m.meeting;
  if (RE.trip.test(q)) return m.trip;
  if (RE.recommend.test(q)) return m.recommend;
  return m.default;
};
